module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/business/business.component.scss
// module id = ./src/app/business/business.component.scss
// module chunks = main